<template>
  <div id="contenedor-listado-tipos-documentos-desktop">
    <v-data-table :headers="headers" :items="listadoTiposDocumentos" :items-per-page="20">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :tipoDocumento="item"></opciones>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoTiposDocumentosDesktop',
  props: {
    listadoTiposDocumentos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        { text: 'Orden', value: 'orden' },
        {
          text: 'Descripción',
          align: 'start',
          value: 'descripcion',
        },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
